<div class="form-group">
  @if (label) {
    <label>{{ label }}@if (requiredMark) {
      <span class="red">*</span>
    }</label>
  }
  <div>
    <textarea
      [rows]="rows"
      [tabindex]="tabId"
      [(ngModel)]="model"
      [autocomplete]="autocomplete"
      placeholder="{{ placeholder }}"
      class="form-control {{ inputClasses }}"
      [ngClass]="{ 'is-invalid': hasValidationError() }"
      (blur)="onBlur($event)"
      [id]="'input-' + formControlName"
      (input)="onChange($event)"
      [disabled]="currentControl.disabled"
    ></textarea>

    @if (hasValidationError()) {
      <div class="invalid-feedback">
        {{ invalidMsg ?? 'GENERAL.invalidValue' | translate }}
      </div>
    }
  </div>
</div>
